const config = {
  AIBackendUrl: "https://x7xh-egts-drcc.n2.xano.io/api:eccG_gFf/",
  GeneralBackendUrl: "https://x7xh-egts-drcc.n2.xano.io/api:lVDXn798/",
  DialogBackendUrl: "https://x7xh-egts-drcc.n2.xano.io/api:7Yj07WtA/",
  DataSource: "live",
  ForgotPasswordUrl: "https://app.unicli.ai/forgot-password/",
};

export default config;
